<template>
  <div class="supplier-management">
    <h3>远程管理</h3>
    <div style="display: flex;justify-content: space-between;align-items: flex-start;">
      <div>
      </div>
      <div style="margin-bottom: 12px;">
        <el-button type="primary" icon="el-icon-plus" @click="addRemote" v-if="user==='root'">新增接入</el-button>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :span="6" v-for="(item, index) in remoteList" :key="index">
        <div
          style="padding: 12px;display: flex;flex-direction: column;justify-content: space-between;box-sizing: border-box;border: 2px solid #e6e7e9;"
        >
          <div
            style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 20px;"
          >
            <div style="display: flex;align-items: center;">
              <div style="margin-right: 10px; display: flex;align-items: center;">
                <img src="../../assets/imgs/remote.svg" style="width: 25px;">
              </div>
              <div>
                <span style="font-size: 18px;font-weight: 700;">{{ `接入服务器: ${item.remoteServerName}` }}</span>
              </div>
            </div>
          </div>
          <div>
            <div style="display: flex;align-items: center;font-size: 12px;height: 80px;margin-bottom: 20px;">
              <div><span style="font-size: 18px;color: #909399;"><i class="el-icon-location-outline"></i>描述</span></div>
              <div>
                <div style="font-size: 17px;margin: 18px 0 0 20px;"><span>{{item.remoteServerDetail}}</span></div>
                </div>
            </div>
          </div>
          <div style="text-align: right;">
            <el-button type="danger" plain @click="del(item)" v-if="user==='root'">删除</el-button>
            <el-button plain @click="edit(item,item.id)" v-if="user==='root'">编辑</el-button>
            <el-button type="primary" @click="checkDetail(item)">查看</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="isShowDialog"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <div slot="title">
        <div class="el-dialog-header-box">
          <div class="dialog-title-block"></div>
          <span class="dialog-title-text">{{`${drawerTip}服务器`}}</span>
        </div>
      </div>
      <el-form
        :model="queryRemoteForm"
        status-icon
        :rules="rules"
        ref="queryRemoteForm"
        label-width="100px"
        style="display: flex;flex-direction: column;justify-content: space-between;"
      >
        <el-form-item label="服务器名称:" prop="remoteServerName">
          <el-input
            v-model="queryRemoteForm.remoteServerName"
            autocomplete="off"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
       <el-form-item label="描述:" prop="remoteServerDetail">
          <el-input
            v-model="queryRemoteForm.remoteServerDetail"
            autocomplete="off"
            placeholder="请输入描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="网络标识:" prop="networkIcon">
          <el-input
            v-model="queryRemoteForm.networkIcon"
            autocomplete="off"
            placeholder="请输入标识"
          ></el-input>
        </el-form-item>
        <el-form-item label="配置文件:" prop="configurationFile">
          <el-input
            type="textarea"
            :rows="5"
            v-model="queryRemoteForm.configurationFile"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="submit" style="margin-top: 20px;margin-left: 200px;">
          <el-button type="primary" @click="submitForm('queryRemoteForm')" style="width: 120px;"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawerTip:'添加',
      user:'',
      editStyle: false,
      pages: 1,
      check: [],
      drawer: false,
      isShowDialog: false,
      remoteList: [],
      total: 10,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        remoteServerName: '',
      },
      queryRemoteForm: {
        remoteServerName: '',
        remoteServerDetail:'',
        networkIcon:'',
        configurationFile:''
      },
      rules: {
        remoteServerName: [{ required: true, message: '请输入名称(最大长度255)', trigger: 'blur' , min: 1, max: 255}],
        remoteServerDetail:[{ required: true, message: '请输入描述(最大长度255)', trigger: 'blur', min: 1, max: 255 }],
         networkIcon:[{ required: true, message: '请输入标识(最大长度255)', trigger: 'blur',min: 1, max: 255 }],
        configurationFile:[{ required: true, message: '请输入配置文件(最大长度50000)', trigger: 'blur' ,min: 1, max: 50000 }],
      },
      delList: [],
      delOne: [],
    }
  },
  created() {
    this.getList()
  },

  methods: {

    addRemote() {
      this.editStyle = false
      this.drawerTip='添加'
      this.queryRemoteForm = {
        remoteServerName: '',
        remoteServerDetail:'',
        networkIcon:'',
        configurationFile:''
      }
      this.isShowDialog = true
    },
    edit(item,id) {
      this.editStyle = true
      this.drawerTip='编辑'
      this.isShowDialog = true
      this.queryRemoteForm = Object.assign({}, item,id)
    },
    handleClose:function(){
      this.isShowDialog = false
      this.$refs.queryRemoteForm.clearValidate()
    },
    // closeDialog() {
    //   this.$refs.queryRemoteForm.clearValidate()
    // },
    submitForm(formName) {
      if (this.editStyle) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$api.post('/datacenter/updateRemoteServer', this.queryRemoteForm, (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '编辑成功',
                  type: 'success',
                })
                this.isShowDialog = false
                this.getList()
              } else {
               this.$message.error(`编辑失败，${res.data.msg}`)
                this.isShowDialog = false
              }
            })
          } else {
            return false
          }
        })   
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$api.post('/datacenter/insertRemoteServer', this.queryRemoteForm, (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success',
                })
                this.isShowDialog = false
                this.getList()
              } else {
                this.$message.error(`添加失败，${res.data.msg}`)
                this.isShowDialog = false
              }
            })
          } else {
            return false
          }
        })
      }
      
    },
    del(item){
        this.$confirm('确定删除该远程服务器吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/deleteRemoteServer', item, (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '删除成功',
                  type: 'success',
                })
                this.getList()
              } else {
                this.$message({
                  message: '删除失败',
                  type: 'error',
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
       
    },
    checkDetail(item){
      this.$store.commit('updateServerDetail', item.remoteServerDetail)
      this.$store.commit('updateServerName',item.remoteServerName)
      this.$store.commit('updateList', item)
      this.$store.commit('updateTabs', {
        tag: 'remove',
        targetName: '10-1',
      })
      this.$store.commit('updateTabs', {
        tag: 'add',
        tab: {
          name: 'remoteList',
          title: '远程列表',
        },
      })
    },
    getList () {
      this.$api.post('/datacenter/selectList',{}, (res) => {
        if(res.data.code==200) {
          this.remoteList = res.data.data    
          this.user=this.$store.state.userId
        }
      })
    },
  },
}
</script>
<style scoped>
::v-deep .el-pagination__jump {
  margin-left: 0 !important;
}
/* ::v-deep .el-input {
  width: 300px;
} */
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
  margin-bottom: 20px;
}
.bg-purple {
  border: 1px solid #dcdfe6;
}
.grid-content {
  border-radius: 4px;
  height: 225px;
}
.el-dialog-header-box {
  display: flex;
  flex-direction: row;
}
.dialog-title-block {
  background-color: #3399ff;
  width: 4px;
  height: 20px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
.dialog-title-text {
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-weight: 700;
}
::v-deep .submit .el-form-item__content {
  margin: 0 !important;
  width: 200px;
}
::v-deep .el-popover {
  min-width: 80px!important;
}
</style>
